<template>
  <div class="row m-b-lg m-t-lg wrapper" v-if="task.pbn">
    <modal-form modal-id="add-blocker">
      <div slot="title">Add Task Blocker</div>
      <div slot="form">
        <div class="col-lg-12">
          <v-select :options="['login','tech-issue']" v-model="blocker['type']" placeholder="Type"></v-select>
        </div>
        <div class="col-lg-12 m-t-xs">
          <textarea v-model="blocker['message']" rows="10" class="form-control"></textarea>
        </div>
        <div class="col-lg-12 m-t-xs">
          <button class="btn btn-xs btn-primary" @click="addBlocker"><i class="fa fa-plus"></i> Add</button>
        </div>
      </div>
    </modal-form>
    <modal-form modal-id="remove-blocker">
      <div slot="title">Remove Task Blocker</div>
      <div slot="form">
        <div class="col-lg-12 m-t-xs">
          <textarea v-model="blocker['message']" rows="10" class="form-control"></textarea>
        </div>
        <div class="col-lg-12 m-t-xs">
          <button class="btn btn-xs btn-primary" @click="removeBlocker"><i class="fa fa-check"></i> Remove</button>
        </div>
      </div>
    </modal-form>
    <div class="col-md-12 row">
      <h2 class="col-lg-6">
        <span :class="'m-l-xs m-r-xs label label-' + (task.priority === '1' ? 'default' : (task.priority === '2' ? 'info' : 'danger'))"><i class="fa fa-tasks"></i></span>
        {{ task.title }}
      </h2>
      <div class="row" v-if="task.status !== 'completed' && task.status !== 'closed'">
          <button class="btn btn-sm btn-primary pull-right" @click="completeTask"><i class="fa fa-check"></i> Complete</button>
          <button class="btn btn-sm btn-default pull-right m-r-sm" @click="closeTask"><i class="fa fa-close"></i> Close</button>
          <button class="btn btn-sm btn-danger pull-right m-r-sm" data-toggle="modal" data-target="#add-blocker" v-if="!task.blocker"><i class="fa fa-ban"></i> Report blocker</button>
          <button class="btn btn-sm btn-success pull-right m-r-sm" data-toggle="modal" data-target="#remove-blocker" v-else><i class="fa fa-ban"></i> Remove blocker</button>
      </div>
      <div v-else>
        <button
          class="btn btn-sm btn-warning pull-right"
          @click="updateTask('status', task.assignee ? 'assigned' : 'created')"
        ><i class="fa fa-check"></i> Reopen task</button>
      </div>
    </div>
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-2">
          <table class="table small m-b-xs">
            <tbody>
            <tr>
              <td>Pbn:</td>
              <td>
                <span>
                  <strong><router-link :to="'/pbn/' + task.pbn.punyDomain">{{ task.pbn.domain }}</router-link></strong>
                  <a :href="'/pbn/' + task.pbn.punyDomain" target="_blank"><i class="fa fa-external-link"></i></a>
                </span>
              </td>
            </tr>
            <tr>
              <td>Client:</td>
              <td>{{ task.pbn.client.name }}</td>
            </tr>
            <tr>
              <td>Order:</td>
              <td>
                <span v-if="task.order">
                  <router-link :to="'/maintenance/order/' + task.order.id">{{ task.order.name }}</router-link>
                  <a :href="'/maintenance/order/' + task.order.id" target="_blank"><i class="fa fa-external-link"></i></a>
                </span>
                <span v-else>/</span>
              </td>
            </tr>
            <tr>
              <td>Priority:</td>
              <td>{{ prios[task.priority] }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-2">
          <table class="table small m-b-xs">
            <tbody>
            <tr>
              <td>Type:</td>
              <td>
                {{ task.type }}
              </td>
            </tr>
            <tr>
              <td>Status:</td>
              <td>
                {{ task.status }}
              </td>
            </tr>
            <tr>
              <td>Created:</td>
              <td>
                {{ task.created.date | moment('from') }}
              </td>
            </tr>
            <tr>
              <td>Updated:</td>
              <td>
                {{ task.updated | aTime('from') }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-2">
          <table class="table small m-b-xs">
            <tbody>
            <tr>
              <td>By:</td>
              <td>
                {{ task.creator ? task.creator.name : 'system' }}
              </td>
            </tr>
            <tr>
              <td>Assignee:</td>
              <td>
                <e-txt
                  type="select"
                  :text="task.assignee ? task.assignee.name : '/'"
                  :options="[{name: '>>>', id: null}].concat(filters.users)"
                  select-value="id"
                  select-label="name"
                  :selected-value="task.assignee ? task.assignee.id : null"
                  :close-on-save="true"
                  @input="updateTask('assignee', $event, 'int')"
                  :locked="!user.admin"
                ></e-txt>
              </td>
            </tr>
            <tr>
              <td>Blocked:</td>
              <td>
                <span v-if="task.blocker" class="red">Yes</span>
                <span v-else class="green">No</span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-4">
        </div>
        <div class="col-md-2">
          <button class="btn btn-xs btn-success pull-right"
            v-if="user.admin && (!task.assignee || task.assignee.id !== user.id)"
                  @click="updateTask('assignee', user.id, 'int')"
          ><i class="fa fa-user-plus"></i> Assign to me</button>
        </div>
      </div>
      <div class="row" v-if="task.tags">
        <div class="col-lg-12">
          Tags: <div v-for="tag in task.tags" class="label label-info float-left m-sm" :key="'tag-' + tag">{{ tag }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Form from '../../../Helpers/Modal/Form'
import axios from 'axios'
import { TASK_SET } from '../../../../store/mutation-types'
import EditText from '../../../Helpers/Form/EditText'

export default {
  data () {
    return {
      blocker: {},
      prios: {
        1: 'Low',
        2: 'Medium',
        3: 'High'
      }
    }
  },
  mounted () {
    if (!this.filters.clients) {
      this.$store.dispatch('loadFilters')
    }
  },
  components: {
    modalForm: Form,
    eTxt: EditText
  },
  computed: {
    ...mapGetters({
      task: 'getTask',
      filters: 'getFilters',
      user: 'getUser'
    })
  },
  methods: {
    addBlocker () {
      if (!this.blocker.type) {
        this.$toastr.error('Please select blocker type')
      }
      let data = this.blocker

      axios.post(`/maintenance/task/${this.task.id}/blocker`, data)
        .then(r => {
          this.$store.commit(TASK_SET, r.data.task)
          $('#add-blocker').modal('hide')
          this.blocker = {}
        })
        .catch(e => {
          this.$toastr.error(e.response.data.msg)
        })
    },
    removeBlocker () {
      let data = this.blocker

      axios.patch(`/maintenance/task/${this.task.id}/blocker`, data)
        .then(r => {
          this.$store.commit(TASK_SET, r.data.task)
          $('#remove-blocker').modal('hide')
          this.blocker = {}
        })
        .catch(e => {
          this.$toastr.error(e.response.data.msg)
        })
    },
    completeTask () {
      let data = {
        status: 'completed'
      }
      axios.patch(`/maintenance/task/${this.task.id}`, data)
        .then(r => {
          this.$toastr.success('Task successfully completed', 'Good job!')
          this.$store.commit(TASK_SET, r.data.task)
        })
        .catch(e => {})
    },
    reopenTask () {},
    updateTask (prop, val, transform = null) {
      console.log(prop, val)
      let data = {}
      if (transform === 'int') {
        val = parseInt(val)
      }
      data[prop] = val
      axios.patch(`/maintenance/task/${this.task.id}`, data)
        .then(r => {
          this.$store.commit(TASK_SET, r.data.task)
          this.$toastr.success(`${prop} has been updated`)
        })
    },
    closeTask () {
      if (confirm('Close task?')) {
        this.updateTask('status', 'closed')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/MaintenanceOrder/Task/Header.vue